import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Vehicle, PurchaseMethodsV25 } from '@sm360/widget-commons-vehicle';
import 'build-and-quote/components/Summary/components/Disclaimers/Disclaimers.scss';

const { DisclaimerAPIService } = PurchaseMethodsV25;

const Disclaimers = ({ legalDisclaimerCz, vehicleDisclaimer }) => {
    const [genericDisclaimers, setGenericDisclaimers] = useState([]);

    useEffect(() => {
        DisclaimerAPIService.getGenericDisclaimers().then((disclaimers) => {
            const specificGenericDisclaimers = [];
            if (disclaimers?.priceChange) specificGenericDisclaimers.push(disclaimers.priceChange);

            setGenericDisclaimers(specificGenericDisclaimers);
        });
    }, []);

    return (
        <div className="sr-disclaimer">
            <Vehicle.VehicleDisclaimersContent
                disclaimersContentZone={legalDisclaimerCz}
                genericDisclaimers={genericDisclaimers}
                uniqueDisclaimer={vehicleDisclaimer}
                onOrderDisclaimer
            />
        </div>
    );
};

Disclaimers.defaultProps = {
    legalDisclaimerCz: '',
};

Disclaimers.propTypes = {
    legalDisclaimerCz: PropTypes.string,
    vehicleDisclaimer: PropTypes.string.isRequired,
};

Disclaimers.displayName = 'Disclaimers';

export default Disclaimers;
